import { ChargerModelEnum } from '../enums/ChargerModelEnum';

export const CHARGER_MODELS = Object.values(ChargerModelEnum);
